import { RemoteFile } from '../../../data/usecases/files/remote-files'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeFiles = () => (
  new RemoteFile('/files', makeAxiosHttpClient())
)
